module.exports = __webpack_public_path__ + "img/green_arrow_right.30322943.png";